module.exports = __webpack_public_path__ + "img/Animales-BRAZO-EXTENSOR.4207bfb9.png";